import { Button, Card, Form, Grid, Menu, Pagination, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import PageContainer from '../../common/PageContainer';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import AddRepModal from './AddRepModal';
import { bindActionCreators } from 'redux';
import EditRepModal from './EditRepModal';
import { Formik } from 'formik';

const RepSearchPage = ({ getReps, firmOptions, reps, pages, paginate, activePage, setActivePage, setQuery }) => {
  useEffect(() => getReps(), []);

  return (
    <PageContainer>
      <Menu borderless size="small">
        <Menu.Item header>Realtors</Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item header>
            <AddRepModal />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Grid>
        <Grid.Column computer="13" tablet="10">
          <Table sortable celled compact="very" size="small" selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Firm</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {reps.map((rep, idx) => (
                <EditRepModal rep={rep} key={idx} />
              ))}
            </Table.Body>
          </Table>

          <br />

          <div style={{ display: 'grid', justifyContent: 'center' }}>
            <Pagination
              size="small"
              onPageChange={(e, { activePage }) => paginate(activePage)}
              activePage={activePage || 1}
              totalPages={pages}
            />
          </div>
        </Grid.Column>
        <Grid.Column computer="3" tablet="6">
          <Card fluid>
            <Card.Content>
              <Formik
                enableReinitialize
                initialValues={{
                  repId: '',
                  firmId: '',
                  name: '',
                }}
                onSubmit={values => {
                  setActivePage(1);
                  setQuery(values);
                  getReps();
                }}
              >
                {formik => (
                  <Form size="small">
                    <Form.Field>
                      <Form.Input
                        id="name"
                        search
                        fluid
                        value={formik.values.name}
                        name="name"
                        label="Name"
                        placeholder="Name"
                        onChange={(e, { value }) => formik.setFieldValue('name', value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <Form.Select
                        id="firm"
                        search
                        fluid
                        options={firmOptions}
                        value={formik.values.firmId}
                        name="firmId"
                        label="Firm"
                        placeholder="Firm"
                        onChange={(e, { value }) => formik.setFieldValue('firmId', value)}
                      />
                    </Form.Field>
                    <br />
                    <Button size="small" type="submit" onClick={formik.handleSubmit} content="Search" fluid positive />
                    <br />
                    <Button
                      type="button"
                      size="small"
                      onClick={() => {
                        formik.resetForm();
                        setQuery(formik.initialValues);
                        formik.handleSubmit();
                      }}
                      content="Clear"
                      fluid
                    />
                  </Form>
                )}
              </Formik>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  reps: selectors.reps.reps(state),
  pages: selectors.reps.pages(state),
  activePage: selectors.reps.activePage(state),
  query: selectors.reps.activePage(state),
  repOptions: selectors.reps.repOptions(state),
  firmOptions: selectors.firms.firmLookupOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getReps: bindActionCreators(actions.rep.getReps, dispatch),
  paginate: bindActionCreators(actions.rep.paginate, dispatch),
  setActivePage: bindActionCreators(actions.rep.setActivePage, dispatch),
  setQuery: bindActionCreators(actions.rep.setQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RepSearchPage);
